import { TableCompHead } from '../../../../components/ui';
import { useQuery } from '../../../../hooks/UseQuery';
import { getColumnLength } from '../../helpers/utils';

interface IProps {
  moduleData: any;
  isView: boolean;
}
const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
  minWidth: '100px',
};
const style2 = {
  backgroundColor: '#00B050',
  color: '#fff',
  minWidth: '80px',
};
const THead = ({ moduleData, isView }: IProps) => {
  const annual_date = useQuery('annual_date');
  const numberOfDays = getColumnLength(annual_date || '');

  return (
    <thead>
      <TableCompHead
        // colSpan={numberOfDays + 7}
        colSpan={9}
        rowSpan={1}
        labels={[]}
        values={[]}
        headingStyle={{
          position: 'sticky',
          top: '0rem',
          zIndex: 1,
        }}
        heading={`Sales Plan ${annual_date}`}
      />
      <tr
        style={{
          position: 'sticky',
          top: '3rem',
          zIndex: 1,
        }}
      >
        <th style={style1}>Customer</th>
        <th style={style1}>Part Name</th>
        <th style={style1}>Part Code</th>
        <th style={style1}>Rate / Piece</th>
        <th style={style1}>Sale Plan</th>
        <th style={style1}>Sale Plan Amount</th>

        <th style={style1}>Total Dispatch</th>
        <th style={style1}>Sale Amount</th>
        <th style={style1}>Balance</th>
      </tr>
    </thead>
  );
};

export default THead;
